export default __webpack_public_path__ + "static/media/pro.1174462e.png";